<template>
  <div class="app" :class="themeStore.getThemeClass()">
    <header v-if="showGlobalHeader" class="header">
      <div class="header-container">
        <div class="header-content">
          <router-link to="/home" class="logo">
            <img :src="logoUrl" alt="数漫短剧" class="logo-img" />
          </router-link>

          <div class="header-center">
            <div class="search-box">
              <input
                v-model="searchKeyword"
                class="search-input"
                placeholder="搜索你想看的短剧/内容"
                @keydown.enter.prevent="onSearch"
                @input="onSearchInput"
              />
              <button class="search-btn" type="button" @click="onSearch">
                <span class="search-divider"></span>
                <img :src="searchIcon" alt="" class="search-icon" />
                <span class="search-text">搜索</span>
              </button>
            </div>
          </div>

          <div class="user-info">
            <div class="header-icon-group">
              <!-- 全部产品：悬停图标/文字展开弹窗；下拉箭头只响应点击，悬浮不触发展开 -->
              <div
                class="all-products-trigger"
                :class="{ 'is-popup-open': allProductsPopupVisible }"
                @mouseleave="onAllProductsLeave"
              >
                <div class="all-products-btn" @mouseenter="onAllProductsEnter">
                  <img :src="allProductIcon" alt="" class="all-products-grid-icon" />
                  <span class="all-products-text">全部产品</span>
                </div>
                <button
                  type="button"
                  class="all-products-arrow-btn"
                  @click="toggleAllProductsPopup"
                >
                  <img :src="allProductDownIcon" alt="" class="all-products-arrow" />
                </button>
                <div v-show="allProductsPopupVisible" class="all-products-popup">
                  <a
                    v-for="item in allProducts"
                    :key="item.name"
                    class="all-products-item"
                    :href="item.link"
                    :target="item.external ? '_blank' : undefined"
                    :rel="item.external ? 'noopener noreferrer' : undefined"
                    @click="onAllProductClick(item, $event)"
                  >
                    <div class="all-products-item-info">
                      <div class="all-products-item-head">
                        <span class="all-products-item-title">{{ item.name }}</span>
                        <span v-if="item.current" class="all-products-item-badge">当前使用</span>
                      </div>
                      <p class="all-products-item-desc">{{ item.desc }}</p>
                    </div>
                    <img :src="allProductRightIcon" alt="" class="all-products-item-arrow" />
                  </a>
                </div>
              </div>
              <button
                type="button"
                class="icon-btn icon-img-btn"
                @click="openConsultModal"
              >
                <img :src="consultIcon" alt="" class="icon-img" />
              </button>
              <div
                class="vip-trigger"
                :class="{ 'is-popup-open': vipPopupVisible }"
                @mouseenter="onVipEnter"
                @mouseleave="onVipLeave"
              >
                <button
                  type="button"
                  class="icon-btn icon-img-btn"
                  @mouseenter="onIconEnter(0)"
                  @click="onVipIconClick"
                >
                  <img :src="getRightIcon(0)" alt="" class="icon-img" />
<!--                  <span class="icon-label">{{ vipNavLabel }}</span>-->
                </button>
                <div v-show="vipPopupVisible && !isMobileBrowser" class="vip-popup">
                  <div class="vip-popup-title">
                    <span class="vip-title-line"></span>
                    <span class="vip-title-text">VIP尊享特权</span>
                    <span class="vip-title-line"></span>
                  </div>
                  <div class="vip-popup-benefits">
                    <div class="vip-benefit-row">
                      <div class="vip-benefit-item">
                        <img :src="vipIcon1" alt="" class="vip-benefit-icon" />
                        <span class="vip-benefit-text">全剧免费</span>
                      </div>
                      <div class="vip-benefit-item">
                        <img :src="vipIcon2" alt="" class="vip-benefit-icon" />
                        <span class="vip-benefit-text">甄选高清</span>
                      </div>
                    </div>
                    <div class="vip-benefit-row">
                      <div class="vip-benefit-item">
                        <img :src="vipIcon3" alt="" class="vip-benefit-icon" />
                        <span class="vip-benefit-text">免广告</span>
                      </div>
                      <div class="vip-benefit-item">
                        <img :src="vipIcon4" alt="" class="vip-benefit-icon" />
                        <span class="vip-benefit-text">加速缓存</span>
                      </div>
                    </div>
                  </div>
                  <button type="button" class="vip-popup-btn" @click="onGoVipClick">
                    开通数漫产线短剧VIP
                  </button>
                </div>
              </div>
              <a
                href="http://video.dmaline.com/"
                target="_blank"
                rel="noopener noreferrer"
                class="goto-video-link"
                @click="onGotoVideoClick"
              >
                <img :src="gotoVideoImg" alt="AI视频创作中心" class="goto-video-img" />
              </a>
              <!-- 顶部「手机端」二维码弹窗：按产品要求暂时隐藏，恢复展示将 showHeaderMobileAppPopup 改为 true -->
              <div
                v-if="showHeaderMobileAppPopup"
                class="mobile-trigger"
                :class="{ 'is-popup-open': mobilePopupVisible }"
                @mouseenter="onMobileEnter"
                @mouseleave="onMobileLeave"
              >
                <button
                  type="button"
                  class="icon-btn icon-img-btn"
                  @mouseenter="onIconEnter(1)"
                >
                  <img :src="getRightIcon(1)" alt="" class="icon-img" />
                  <span class="icon-label">{{ rightIcons[1].label }}</span>
                </button>
                <div v-show="mobilePopupVisible" class="mobile-popup">
                  <img :src="mobileLogo" alt="" class="mobile-logo" />
                  <div class="mobile-subtitle">
                    扫码或者小程序搜索「数字产线短剧」海量短漫免费看全集
                  </div>
                  <img :src="mobileQrcode" alt="二维码" class="mobile-qrcode" />
                </div>
              </div>
            </div>
            <template v-if="!userStore.isLogin">
              <a
                v-if="isMobileBrowser"
                href="#"
                class="login-btn"
                @click.prevent="openMobileGuideModal"
              >
                <img :src="loginImg" alt="登录" class="login-img" />
              </a>
              <router-link v-else to="/login" class="login-btn">
                <img :src="loginImg" alt="登录" class="login-img" />
              </router-link>
            </template>
            <template v-else>
              <div
                class="user-trigger"
                :class="{ 'is-popup-open': userPopupVisible }"
                @mouseenter="userPopupVisible = true"
                @mouseleave="userPopupVisible = false"
              >
                <img :src="userAvatar" alt="" class="user-avatar" @click.stop="goEditProfile" />
                <div v-show="userPopupVisible" class="user-popup">
                  <div class="popup-user">
                    <img :src="userAvatar" alt="" class="popup-avatar" @click.stop="goEditProfile" />
                    <div class="popup-info">
                      <span class="popup-name">{{ userStore.userInfo?.nickname || '用户' }}</span>
                      <span class="popup-id">ID: {{ userStore.userInfo?.user_id || '---' }}</span>
                    </div>
                  </div>
                  <div class="popup-vip">
                    <div class="popup-vip-card" :class="{ 'popup-vip-card--active': userStore.userInfo?.is_vip }">
                      <img v-if="userStore.userInfo?.is_vip" :src="imgVipBadge" alt="VIP" class="popup-vip-badge" />
                      <img v-else :src="imgVipTitleNoVip" alt="视频会员" class="popup-vip-title" />
                      <p class="popup-vip-desc">{{ userStore.userInfo?.is_vip ? vipExpireText : '开通会员享受更多权益' }}</p>
                      <router-link
                        v-if="userStore.userInfo?.is_vip"
                        to="/vip"
                        class="popup-vip-btn-code"
                        @click="onMobileVipRouteClick"
                      >立即续费</router-link>
                      <router-link
                        v-else
                        to="/vip"
                        class="popup-vip-btn-code"
                        @click="onMobileVipRouteClick"
                      >开通VIP</router-link>
                    </div>
                  </div>
                  <div class="popup-actions">
                    <router-link to="/profile" class="popup-action" @click="userPopupVisible = false">
                      <img src="@/assets/images/M-0207.png" alt="" class="popup-action-icon" />
                      <span class="popup-action-text">个人中心</span>
                    </router-link>
                    <button type="button" class="popup-action" @click="openPurchaseModal">
                      <img src="@/assets/images/M-0706.png" alt="" class="popup-action-icon" />
                      <span class="popup-action-text">购买记录</span>
                    </button>
                    <button type="button" class="popup-action" @click="handleLogout">
                      <img src="@/assets/images/M-0208.png" alt="" class="popup-action-icon" />
                      <span class="popup-action-text">退出登录</span>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </header>
    <!-- 购买记录弹窗：如 UI 设计，240×341 -->
    <Teleport to="body">
      <div v-if="showPurchaseModal" class="purchase-modal-mask" @click.self="showPurchaseModal = false">
        <div class="purchase-modal">
          <div class="purchase-modal-header">
            <h3 class="purchase-modal-title">购买记录</h3>
            <button type="button" class="purchase-modal-close" aria-label="关闭" @click="showPurchaseModal = false">×</button>
          </div>
          <div class="purchase-modal-body">
            <div v-if="purchaseLoading" class="purchase-modal-loading"><div class="loading-spinner small"></div></div>
            <template v-else>
              <div v-if="purchaseRecords.length" class="purchase-record-list">
                <div v-for="(r, i) in purchaseRecords" :key="i" class="purchase-record-item">
                  <div class="purchase-row purchase-row--meta">
                    <span class="purchase-order-no">订单号：{{ r.order_no }}</span>
                    <span class="purchase-status">{{ r.status_text }}</span>
                  </div>
                  <div class="purchase-row purchase-row--main">
                    <span class="purchase-name">{{ r.package_name }}</span>
                  </div>
                  <div class="purchase-row purchase-row--foot">
                    <span class="purchase-time">{{ r.created_at }}</span>
                    <span class="purchase-amount">¥{{ r.amount }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="purchase-modal-empty">暂无购买记录</div>
            </template>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- 免费咨询 / 商务洽谈留资弹窗：527×778 -->
    <Teleport to="body">
      <div
        v-if="consultModalVisible"
        class="consult-modal-mask"
        @click.self="closeConsultModal"
      >
        <div class="consult-modal" role="dialog" aria-modal="true" aria-labelledby="consult-modal-title">
          <button
            type="button"
            class="consult-modal-close"
            aria-label="关闭"
            @click="closeConsultModal"
          >
            ×
          </button>
          <div class="consult-modal-inner">
            <header class="consult-modal-head">
              <h2 id="consult-modal-title" class="consult-modal-title">
                商务洽谈/咨询，请留资
              </h2>
              <p class="consult-modal-subtitle">
                填写信息，专属顾问为您一对一解答，全程免费无骚扰
              </p>
            </header>
            <div class="consult-modal-form">
              <div class="consult-field-group">
                <label class="consult-label" for="consult-nickname">您的称呼（选填）</label>
                <input
                  id="consult-nickname"
                  v-model="consultForm.nickname"
                  type="text"
                  class="consult-field"
                  placeholder="请填写您的称呼 (选填)"
                  autocomplete="name"
                />
              </div>
              <div class="consult-field-group">
                <label class="consult-label" for="consult-phone">手机号码</label>
                <input
                  id="consult-phone"
                  v-model="consultForm.phone"
                  type="tel"
                  class="consult-field"
                  placeholder="方便我们为您回电解答"
                  autocomplete="tel"
                />
              </div>
              <div class="consult-field-group">
                <label class="consult-label" for="consult-email">邮箱地址</label>
                <input
                  id="consult-email"
                  v-model="consultForm.email"
                  type="email"
                  class="consult-field"
                  placeholder="可接收我们的资料 / 回复"
                  autocomplete="email"
                />
              </div>
              <div class="consult-field-group">
                <label class="consult-label" for="consult-interest">您想了解的内容</label>
                <div class="consult-select-wrap">
                  <select
                    id="consult-interest"
                    v-model="consultForm.interest"
                    class="consult-field consult-field--select"
                    :class="{ 'consult-field--muted': !consultForm.interest }"
                  >
                    <option value="" disabled>选择您感兴趣的功能/业务</option>
                    <option v-for="opt in consultInterestOptions" :key="opt" :value="opt">
                      {{ opt }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="consult-field-group">
                <label class="consult-label" for="consult-city">所在城市（选填）</label>
                <input
                  id="consult-city"
                  v-model="consultForm.city"
                  type="text"
                  class="consult-field"
                  placeholder="请输入所在城市"
                  autocomplete="address-level2"
                />
              </div>
              <div class="consult-field-group">
                <label class="consult-label" for="consult-remark">其他说明</label>
                <textarea
                  id="consult-remark"
                  v-model="consultForm.remark"
                  class="consult-field consult-field--textarea"
                  rows="3"
                  placeholder="还有其他疑问或需求？请告诉我们"
                />
              </div>
            </div>
            <footer class="consult-modal-footer">
              <button
                type="button"
                class="consult-submit-btn"
                :disabled="consultSubmitting"
                @click="submitConsultForm"
              >
                {{ consultSubmitting ? '提交中…' : '提交表单' }}
              </button>
            </footer>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- 手机端：引导使用 PC 或小程序（不影响 PC 端交互） -->
    <Teleport to="body">
      <div
        v-if="showMobileGuideModal"
        class="mobile-guide-mask"
        @click.self="closeMobileGuideModal"
      >
        <div class="mobile-guide-modal" role="dialog" aria-modal="true" aria-labelledby="mobile-guide-title">
          <button type="button" class="mobile-guide-close" aria-label="关闭" @click="closeMobileGuideModal">×</button>
          <h3 id="mobile-guide-title" class="mobile-guide-title">完整功能请前往 PC 或小程序</h3>
          <p class="mobile-guide-desc">
            登录、开通会员、AI 视频创作等功能暂不支持手机浏览器，请通过以下方式体验完整版：
          </p>
          <div class="mobile-guide-options">
            <div class="mobile-guide-option">
              <span class="mobile-guide-option-tag">方式一</span>
              <p class="mobile-guide-option-title">电脑浏览器访问</p>
              <a
                href="https://dmaline.com/"
                target="_blank"
                rel="noopener noreferrer"
                class="mobile-guide-link"
              >https://dmaline.com/</a>
            </div>
            <div class="mobile-guide-option mobile-guide-option--mini">
              <span class="mobile-guide-option-tag">方式二</span>
              <p class="mobile-guide-option-title">微信搜索小程序</p>
              <p class="mobile-guide-mini-name">数漫产线</p>
              <div class="mobile-guide-qrcode-wrap">
                <img :src="wxMiniQrcode" alt="数漫产线小程序码" class="mobile-guide-qrcode" />
              </div>
              <p class="mobile-guide-qrcode-tip">长按识别小程序码</p>
            </div>
          </div>
          <button type="button" class="mobile-guide-confirm" @click="closeMobileGuideModal">我知道了</button>
        </div>
      </div>
    </Teleport>

    <!-- 登录弹窗：叠加在当前页面之上（Teleport 至 body，见 LoginModal） -->
    <LoginModal />

    <main class="main-content" :class="{ 'main-content--no-header': !showGlobalHeader }">
      <router-view v-slot="{ Component }">
        <keep-alive :include="['Home', 'Theater', 'Profile']">
          <component v-if="Component" :is="Component" :key="$route.path" />
        </keep-alive>
      </router-view>
    </main>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { useThemeStore } from '@/stores/theme'
import { useUserStore } from '@/stores/user'
import { getFullAvatarUrl } from '@/utils/url'
import { showToast } from '@/utils/toast'
import { getPurchases } from '@/api/vip'
import { createLeadInquiry } from '@/api/leadInquiries'
import { formatPurchaseDateTime, formatPurchaseYuan, pickPurchaseTimeField } from '@/utils/purchaseDisplay'
import LoginModal from '@/components/LoginModal.vue'
import { useLoginModalStore } from '@/stores/loginModal'
import {
  SHOW_MOBILE_GUIDE_EVENT,
  isMobileBrowser
} from '@/utils/mobileLayout'

export default {
  name: 'App',
  components: { LoginModal },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const themeStore = useThemeStore()
    const userStore = useUserStore()
    const loginModalStore = useLoginModalStore()
    const searchKeyword = ref('')
    const userPopupVisible = ref(false)
    const vipPopupVisible = ref(false)
    const mobilePopupVisible = ref(false)
    const allProductsPopupVisible = ref(false)
    // 全部产品弹窗数据：external 为 true 时新窗口打开，否则走站内路由
    const allProducts = [
      { name: '数漫产线', desc: 'AI短剧、广告片录制与图片制作', current: true, link: '/home', external: false },
      { name: '数字产线', desc: '工作流、智能体定制与企业营销', current: false, link: 'https://degeline.com/', external: true },
      { name: '数创产线', desc: 'AI视频、广告复刻与笔记批量生成', current: false, link: 'https://vdoline.com/', external: true },
      { name: '租达人', desc: '一站式达人派单营销平台', current: false, link: 'https://zudaren.com/', external: true }
    ]
    const onAllProductsEnter = () => {
      if (isMobileBrowserRef.value) return
      allProductsPopupVisible.value = true
    }
    const onAllProductsLeave = () => {
      allProductsPopupVisible.value = false
    }
    // 下拉箭头：悬浮不展开，仅点击切换
    const toggleAllProductsPopup = () => {
      allProductsPopupVisible.value = !allProductsPopupVisible.value
    }
    function onAllProductClick(item, event) {
      allProductsPopupVisible.value = false
      // 外链交给浏览器按 target="_blank" 打开，中键/右键复制链接也能正常工作
      if (item.external) return
      if (event) event.preventDefault()
      if (item.link) router.push(item.link)
    }
    /** 首页/全局顶栏「手机端」入口与二维码弹窗：false 为暂时关闭 */
    const showHeaderMobileAppPopup = false
    const showPurchaseModal = ref(false)
    const purchaseRecords = ref([])
    const purchaseLoading = ref(false)
    const consultModalVisible = ref(false)
    const consultSubmitting = ref(false)
    const consultInterestOptions = ['短剧漫剧', '广告片', '种草视频', '图文', 'IP设计', '短视频']
    const consultForm = ref({
      nickname: '',
      phone: '',
      email: '',
      interest: '',
      city: '上海',
      remark: ''
    })
    const isMobileBrowserRef = ref(false)
    const showMobileGuideModal = ref(false)

    function updateMobileBrowser() {
      isMobileBrowserRef.value = isMobileBrowser()
    }
    function openMobileGuideModal() {
      loginModalStore.close()
      vipPopupVisible.value = false
      userPopupVisible.value = false
      showMobileGuideModal.value = true
    }
    function closeMobileGuideModal() {
      showMobileGuideModal.value = false
    }
    function onVipIconClick() {
      if (isMobileBrowserRef.value) openMobileGuideModal()
    }
    function onGoVipClick() {
      if (isMobileBrowserRef.value) {
        openMobileGuideModal()
        return
      }
      goVip()
    }
    function onGotoVideoClick(e) {
      if (isMobileBrowserRef.value) {
        e.preventDefault()
        openMobileGuideModal()
      }
    }
    function onShowMobileGuideEvent() {
      openMobileGuideModal()
    }
    function onMobileVipRouteClick(e) {
      if (isMobileBrowserRef.value) {
        e.preventDefault()
        openMobileGuideModal()
      }
    }

    const userAvatar = computed(() => {
      const u = userStore.userInfo
      const url = getFullAvatarUrl(u?.user_id || u?.id, u?.avatar)
      return url || '/static/icons/avatar-placeholder.svg'
    })
    const vipExpire = computed(() => {
      const t = userStore.userInfo?.vip_expire_time
      if (!t) return '---'
      const d = new Date(t)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    })
    const vipExpireText = computed(() => {
      const t = userStore.userInfo?.vip_expire_time
      if (!t || !userStore.userInfo?.is_vip) return '开通会员享受更多权益'
      const d = new Date(t)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}.${m}.${day}到期`
    })
    const isProfileActive = computed(() => {
      const p = route.path
      return p === '/profile' || p.startsWith('/profile') || p.startsWith('/user/')
    })
    const showGlobalHeader = computed(() => route.meta?.hideGlobalHeader !== true)

    function resetConsultForm() {
      consultForm.value = {
        nickname: '',
        phone: '',
        email: '',
        interest: '',
        city: '上海',
        remark: ''
      }
    }
    function openConsultModal() {
      consultModalVisible.value = true
    }
    function closeConsultModal() {
      consultModalVisible.value = false
    }
    async function submitConsultForm() {
      const f = consultForm.value
      const phone = String(f.phone || '').trim()
      const email = String(f.email || '').trim()
      if (!phone) {
        showToast('请填写手机号码')
        return
      }
      if (!/^1\d{10}$/.test(phone)) {
        showToast('请输入正确的11位手机号码')
        return
      }
      if (!f.interest) {
        showToast('请选择您想了解的内容')
        return
      }
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showToast('请输入正确的邮箱地址')
        return
      }
      const city = String(f.city || '').trim() || '上海'
      const payload = {
        phone,
        interest: String(f.interest || '').trim(),
        city
      }
      const salutation = String(f.nickname || '').trim()
      if (salutation) payload.salutation = salutation
      if (email) payload.email = email
      const remark = String(f.remark || '').trim()
      if (remark) payload.remark = remark
      consultSubmitting.value = true
      try {
        await createLeadInquiry(payload)
        showToast('提交成功，我们会尽快与您联系')
        closeConsultModal()
        resetConsultForm()
      } catch (e) {
        const msg =
          e && typeof e === 'object' && typeof e.detail === 'string'
            ? e.detail
            : '提交失败，请稍后重试'
        showToast(msg)
      } finally {
        consultSubmitting.value = false
      }
    }
    function onSearch() {
      const q = String(searchKeyword.value || '').trim()
      if (!q) {
        if (route.path === '/searchResult') router.replace('/home')
        return
      }
      router.push({ path: '/searchResult', query: { keyword: q } })
    }
    function onSearchInput() {
      nextTick(() => {
        const q = String(searchKeyword.value || '').trim()
        if (!q && route.path === '/searchResult') router.replace('/home')
      })
    }

    watch(
      () => [route.path, route.query.keyword, route.query.q],
      () => {
        if (route.path === '/searchResult') {
          searchKeyword.value = String(route.query.keyword || route.query.q || '')
        } else if (route.path === '/home' || route.path === '/') {
          searchKeyword.value = ''
        }
      },
      { immediate: true }
    )
    function goEditProfile() {
      userPopupVisible.value = false
      router.push('/user/edit-profile')
    }
    function handleLogout() {
      userStore.logout()
      showToast('已退出')
      router.push('/home')
      userPopupVisible.value = false
    }

    onMounted(() => {
      themeStore.initTheme()
      updateMobileBrowser()
      window.addEventListener('resize', updateMobileBrowser)
      window.addEventListener(SHOW_MOBILE_GUIDE_EVENT, onShowMobileGuideEvent)
    })
    onUnmounted(() => {
      window.removeEventListener('resize', updateMobileBrowser)
      window.removeEventListener(SHOW_MOBILE_GUIDE_EVENT, onShowMobileGuideEvent)
    })

    const logoUrl = require('@/assets/images/M-09logo1.png')
    const searchIcon = require('@/assets/images/M-0103.png')
    const loginImg = require('@/assets/images/M-0110.png')
    const themeStyleIcon = require('@/assets/images/M-0201.png')
    const themeCheckIcon = require('@/assets/images/M-0202.png')
    const vipIcon1 = require('@/assets/images/M-0203.png')
    const vipIcon2 = require('@/assets/images/M-0204.png')
    const vipIcon3 = require('@/assets/images/M-0205.png')
    const vipIcon4 = require('@/assets/images/M-0206.png')
    const mobileLogo = require('@/assets/images/M-09logo2.png')
    const mobileQrcode = require('@/assets/images/M-0209.png')
    const vipTitleIcon = require('@/assets/images/M-0314.png')
    const imgVipBadge = require('@/assets/images/M-0608.png')
    const imgVipTitleNoVip = require('@/assets/images/M-0812.png')
    const consultIcon = require('@/assets/images/M-11console.png')
    const gotoVideoImg = require('@/assets/images/goto_video.png')
    const wxMiniQrcode = require('@/assets/images/wx_img.png')
    const vipHeaderIcon = require('@/assets/images/M-0106.png')
    const vipHeaderIconHover = require('@/assets/images/M-0107.png')
    const vipHeaderIconVip = require('@/assets/images/M-0129.png')
    const allProductIcon = require('@/assets/images/allproduct/all.png')
    const allProductDownIcon = require('@/assets/images/allproduct/all-down.png')
    const allProductRightIcon = require('@/assets/images/allproduct/all-right.png')

    const rightIcons = computed(() => [
      {
        normal: userStore.userInfo?.is_vip ? vipHeaderIconVip : vipHeaderIcon,
        // 已是会员：按需求使用 M-0129.png；无单独 hover 图时保持一致
        // 取消“开通会员”按钮 hover 换图效果：hover 与 normal 保持一致
        hover: userStore.userInfo?.is_vip ? vipHeaderIconVip : vipHeaderIcon,
        label: userStore.userInfo?.is_vip ? '升级会员' : '开通会员'
      },
      {
        normal: require('@/assets/images/M-0108.png'),
        hover: require('@/assets/images/M-0109.png'),
        label: '手机端'
      }
    ])
    const vipNavLabel = computed(() => rightIcons.value[0].label)

    const iconHoverIndex = ref(-1)
    const getRightIcon = (idx) =>
      iconHoverIndex.value === idx ? rightIcons.value[idx].hover : rightIcons.value[idx].normal
    const onIconEnter = (idx) => {
      iconHoverIndex.value = idx
    }
    const onIconLeave = () => {
      iconHoverIndex.value = -1
    }
    const onVipEnter = () => {
      if (isMobileBrowserRef.value) return
      iconHoverIndex.value = 0
      vipPopupVisible.value = true
    }
    const onVipLeave = () => {
      iconHoverIndex.value = -1
      vipPopupVisible.value = false
    }
    const onMobileEnter = () => {
      iconHoverIndex.value = 1
      mobilePopupVisible.value = true
    }
    const onMobileLeave = () => {
      iconHoverIndex.value = -1
      mobilePopupVisible.value = false
    }
    function goVip() {
      router.push('/vip')
    }
    function getPurchaseStatusText(status) {
      const map = { 0: '待支付', 1: '已支付', 2: '已取消', 3: '已退款' }
      return map[status] ?? '未知'
    }
    async function openPurchaseModal() {
      userPopupVisible.value = false
      showPurchaseModal.value = true
      purchaseLoading.value = true
      purchaseRecords.value = []
      try {
        const res = await getPurchases({ page: 1, page_size: 20 })
        const list = res?.items || res || []
        const vipOnly = list.filter((p) => p.item_type === 'vip' || p.item_type === 'VIP')
        purchaseRecords.value = vipOnly.map((p) => ({
          order_no: p.order_no || p.purchase_id || p.id || '—',
          package_name: p.item_name || 'VIP会员',
          amount: formatPurchaseYuan(p),
          created_at: formatPurchaseDateTime(pickPurchaseTimeField(p)),
          status: p.status,
          status_text: getPurchaseStatusText(p.status)
        }))
      } catch (e) {
        purchaseRecords.value = []
      } finally {
        purchaseLoading.value = false
      }
    }
    return {
      themeStore,
      userStore,
      searchKeyword,
      onSearch,
      onSearchInput,
      userPopupVisible,
      vipPopupVisible,
      mobilePopupVisible,
      allProductsPopupVisible,
      allProducts,
      allProductIcon,
      allProductDownIcon,
      allProductRightIcon,
      onAllProductsEnter,
      onAllProductsLeave,
      toggleAllProductsPopup,
      onAllProductClick,
      showHeaderMobileAppPopup,
      themeStyleIcon,
      themeCheckIcon,
      vipIcon1,
      vipIcon2,
      vipIcon3,
      vipIcon4,
      mobileLogo,
      mobileQrcode,
      vipTitleIcon,
      userAvatar,
      vipExpire,
      vipExpireText,
      imgVipBadge,
      imgVipTitleNoVip,
      consultIcon,
      gotoVideoImg,
      isProfileActive,
      showGlobalHeader,
      logoUrl,
      searchIcon,
      loginImg,
      rightIcons,
      vipNavLabel,
      iconHoverIndex,
      getRightIcon,
      onIconEnter,
      onIconLeave,
      onVipEnter,
      onVipLeave,
      onMobileEnter,
      onMobileLeave,
      goVip,
      goEditProfile,
      consultModalVisible,
      consultForm,
      consultInterestOptions,
      consultSubmitting,
      openConsultModal,
      closeConsultModal,
      submitConsultForm,
      handleLogout,
      showPurchaseModal,
      purchaseRecords,
      purchaseLoading,
      openPurchaseModal,
      isMobileBrowser: isMobileBrowserRef,
      showMobileGuideModal,
      wxMiniQrcode,
      closeMobileGuideModal,
      onVipIconClick,
      onGoVipClick,
      onGotoVideoClick,
      openMobileGuideModal,
      onMobileVipRouteClick
    }
  }
}
</script>

<style scoped>
.app {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 66px;
  background: #05070b;
  z-index: 1001;
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.08); */
}
.header-container {
  width: 100%;
  height: 100%;
  padding: 0 25px;
  box-sizing: border-box;
}
.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
}
.logo {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  text-decoration: none;
}
.logo-img {
  width: 132px;
  height: 30px;
  object-fit: contain;
  display: block;
}
.user-info {
  margin-left: auto;
  display: flex;
  align-items: flex-end;
  gap: 20px;
}

.header-center {
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 0 40px;
}
.search-box {
  max-width: 600px;
  flex: 1;
  display: flex;
  align-items: center;
  /* background: #11131b; */
  /* border-radius: 999px; */
  padding: 4px;
  /* border: 1px solid rgba(255, 255, 255, 0.06); */
  height: 42px;
  background: #1A1A1A;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #262626;
}
.search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  padding: 6px 14px;
  font-size: 14px;
}
.search-input::placeholder {
  color: #767676;
}
.search-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 999px;
  padding: 6px 16px 6px 14px;
  background: #1a1a1a;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.search-icon {
  width: 16px;
  height: 16px;
  display: block;
}
.search-divider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.16);
}
.search-text {
  font-weight: 400;
font-size: 14px;
color: #FFFFFF;
}

.header-icon-group {
  display: flex;
  align-items: flex-end;
  gap: 20px;
}
.all-products-trigger {
  position: relative;
  align-self: center;
  display: flex;
  align-items: center;
}
/* 悬停桥接区：避免移动到弹窗途中触发 mouseleave */
.all-products-trigger.is-popup-open::after {
  content: '';
  position: absolute;
  top: 100%;
  left: -12px;
  right: -12px;
  height: 40px;
}
.all-products-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
}
/* 下拉箭头独立按钮：只响应点击，不参与 hover 展开 */
.all-products-arrow-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
}
.all-products-grid-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
  display: block;
}
.all-products-text {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
}
.all-products-arrow {
  width: 12px;
  height: 12px;
  object-fit: contain;
  display: block;
}
.all-products-popup {
  position: fixed;
  top: 66px;
  right: 25px;
  width: 575px;
  height: 177px;
  background: #161616;
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6);
  padding: 24px 28px 20px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 40px;
  row-gap: 22px;
  z-index: 10005;
  box-sizing: border-box;
}
.all-products-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
}
.all-products-item:hover .all-products-item-arrow {
  transform: translateX(4px);
}
.all-products-item-info {
  flex: 1;
  min-width: 0;
}
.all-products-item-head {
  display: flex;
  align-items: center;
  gap: 12px;
}
.all-products-item-title {
  font-size: 17px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
}
.all-products-item-badge {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 12px;
  line-height: 1.4;
  color: #ffffff;
  background: #7657ff;
  border-radius: 6px;
  padding: 2px 8px;
  white-space: nowrap;
}
.all-products-item-desc {
  margin: 10px 0 0;
  font-size: 14px;
  color: #a2a2a2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.all-products-item-arrow {
  width: 14px;
  height: 14px;
  margin-top: 5px;
  flex-shrink: 0;
  object-fit: contain;
  display: block;
  transition: transform 0.2s ease;
}
.goto-video-link {
  display: inline-flex;
  flex-shrink: 0;
  line-height: 0;
}
.goto-video-img {
  width: 141px;
  height: 38px;
  display: block;
}
.vip-trigger {
  position: relative;
}
.vip-trigger.is-popup-open::after {
  content: '';
  position: absolute;
  top: 100%;
  left: -60px;
  right: -60px;
  height: 260px;
}
.vip-popup {
  position: fixed;
  top: 74px;
  right: 28px;
  left: auto;
  transform: none;
  margin-top: 0;
  /* min-width: 260px; */
  /* background: #15161d; */
  /* border-radius: 16px; */
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6);
  padding: 30px 20px 16px;
  z-index: 10005;
  width: 273px;
height: 270px;
background: #1F1F1F;
border-radius: 17px 17px 17px 17px;
border: 1px solid #262626;
}
.vip-popup-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 22px;
}
.vip-title-text {
  font-size: 14px;
  color: #ffffff;
}
.vip-title-line {
  flex: 1;
  height: 1px;
  background: #3c3c3c;
}
.vip-popup-benefits {
  display: flex;
  flex-direction: column;
  gap: 23px;
  margin-bottom: 18px;
}
.vip-benefit-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
}
.vip-benefit-item {
  display: flex;
  align-items: center;
  gap: 11px;
  /* color: #ffffff; */
  /* font-size: 13px; */
  font-weight: 400;
font-size: 14px;
color: #A2A2A2;
}
.vip-benefit-icon {
  width: 24px;
height: 24px;
  object-fit: contain;
}
.vip-benefit-text {
  white-space: nowrap;
}
.vip-popup-btn {
  /* width: 100%; */
  margin-top: 30px;
  border: none;

  color: #FFFFFF;
  font-size: 14px;
  cursor: pointer;
  width: 227px;
  height: 38px;
  background: linear-gradient( 90deg, #7657FF 0%, #A357FF 100%);
  border-radius: 20px 20px 20px 20px;
}
.vip-popup-btn:hover {
  opacity: 0.95;
}
.mobile-trigger {
  position: relative;
}
.mobile-trigger.is-popup-open::after {
  content: '';
  position: absolute;
  top: 100%;
  left: -60px;
  right: -60px;
  height: 260px;
}
.mobile-popup {
  position: fixed;
  top: 74px;
  right: 28px;
  left: auto;
  transform: none;
  margin-top: 0;
  width: 310px;
  height: 280px;
  background: #1F1F1F;
  border-radius: 17px 17px 17px 17px;
  border: 1px solid #262626;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6);
  padding: 17px 24px 34px;
  box-sizing: border-box;
  z-index: 10005;
  text-align: center;
}
.mobile-logo {
  width: 96px;
  height: 74px;
  object-fit: contain;
  margin: 0 auto 12px;
}
.mobile-title {

  font-weight: 400;
  font-size: 12px;
  color: #979898;
  margin-bottom: 16px;
}
.mobile-subtitle {
  font-weight: 400;
font-size: 12px;
color: #979898;
}
.mobile-subtitle--secondary {
  margin-top: 4px;
}
.mobile-qrcode {
  width: 84px;
  height: 84px;
  margin: 24px auto 0;
  background: #ffffff;
  padding: 8px;
  box-sizing: border-box;
}
.icon-btn {
  border: none;
  background: transparent;
  cursor: pointer;
}
.icon-img-btn {
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}
.icon-img {
  width: 60px;
  height: 50px;
  display: block;
  object-fit: contain;
}
.icon-label {
  font-weight: 400;
  font-size: 10px;
  color: #A2A2A2;
}
.icon-img-btn:hover .icon-label {
  color: #ffffff;
}

.login-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  color: #fff;
  border: none;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s;
}
.login-img {
  width: 88px;
height: 38px
}
.login-btn:hover {
  opacity: 0.9;
}
.user-trigger {
  position: relative;
  display: flex;
  align-items: center;
  align-self: flex-end;
  gap: 8px;
  cursor: pointer;
  padding: 6px 0;
}
/* 弹窗打开时用伪元素连接头像与弹窗，鼠标移入弹窗可操作，移出弹窗区域后关闭 */
.user-trigger.is-popup-open::after {
  content: '';
  position: absolute;
  top: 100%;
  right: 0;
  width: 240px;
  height: 341px;
}
.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  background: rgba(255, 255, 255, 0.2);
}
.user-text {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}
.user-trigger:hover .user-text {
  color: #316CF4;
}
.user-popup {
  position: fixed;
  top: 74px;
  right: 28px;
  left: auto;
  margin-top: 0;
  width: 240px;
  height: 341px;
  background: #1F1F1F;
  border: 1px solid #262626;
  border-radius: 17px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  z-index: 10005;
  padding: 16px 16px 31px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.popup-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: none;
}
.popup-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  background: rgba(255, 255, 255, 0.1);
}
.popup-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.popup-name {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}
.popup-id {
  font-weight: 400;
  font-size: 11px;
  color: #A2A2A2;
}
.popup-vip {
  padding: 12px 0 8px;
}
.popup-vip-card {
  width: 100%;
  padding: 12px;
  border-radius: 11px;
  background: #292929;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.popup-vip-card--active {
  border: 1px solid rgba(255,255,255,0.1);
}
.popup-vip-badge {
  width: 52px;
  height: 17px;
  object-fit: contain;
  display: block;
  margin-bottom: 8px;
}
.popup-vip-title {
  width: 64px;
  height: 22px;
  object-fit: contain;
  display: block;
  margin-bottom: 8px;
}
.popup-vip-desc {
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  margin: 0 0 10px;
}
.popup-vip-btn-code {
  width: 187px;
  height: 29px;
  background: linear-gradient(90deg, #7657FF 0%, #A357FF 100%);
  border-radius: 28px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  margin: 0 auto;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-vip-btn-code:hover {
  opacity: 0.95;
}
.popup-actions {
  margin-top: auto;
  border-top: none;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.popup-action {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;
}
.popup-action:hover {
  color: #7657FF;
}
.popup-action-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}
.popup-action-text {
  flex: 1;
  text-align: left;
}

/* 购买记录弹窗：如 UI 设计 240×341 */
.purchase-modal-mask {
  position: fixed;
  inset: 0;
  background: #121316;
  z-index: 10010;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.purchase-modal {
  width: 669px;
  height: 749px;
  background: #1A1A1A;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}
.purchase-modal-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 27px 34px 16px;
  border-bottom: none;
}
.purchase-modal-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}
.purchase-modal-close {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
}
.purchase-modal-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 34px;
}
.purchase-modal-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px 0;
}
.purchase-record-list {
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
}
.purchase-record-item {
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.purchase-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.purchase-row--meta {
  margin-bottom: 10px;
}
.purchase-order-no {
  font-weight: 400;
  font-size: 14px;
  color: #AAAAAA;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.purchase-status {
  font-weight: 400;
  font-size: 14px;
  color: #AAAAAA;
  flex-shrink: 0;
}
.purchase-row--main {
  margin-bottom: 10px;
}
.purchase-name {
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
}
.purchase-amount {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  flex-shrink: 0;
}
.purchase-row--foot {
  margin-bottom: 0;
}
.purchase-time {
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}
.purchase-modal-empty {
  text-align: center;
  padding: 48px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

/* 免费咨询 / 商务洽谈留资弹窗 527×778 */
.consult-modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(5, 7, 11, 0.72);
  z-index: 10011;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}
.consult-modal {
  position: relative;
  width: 527px;
  max-width: 100%;
  height: 778px;
  max-height: calc(100vh - 48px);
  background: #1a1a1a;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.55);
  box-sizing: border-box;
  overflow: hidden;
}
.consult-modal-close {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.45);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  padding: 4px 8px;
}
.consult-modal-close:hover {
  color: rgba(255, 255, 255, 0.85);
}
.consult-modal-inner {
  height: 100%;
  padding: 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.consult-modal-head {
  flex-shrink: 0;
  padding-right: 36px;
}
.consult-modal-title {
  margin: 0;
  font-family: HYQiHei, HYQiHei;
  font-weight: normal;
  font-size: 25px;
  color: #FFFFFF;
  line-height: 1.35;
}
.consult-modal-subtitle {
  margin: 12px 0 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #A2A2A2;
  line-height: 1.55;
}
.consult-modal-form {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin-top: 28px;
  padding-right: 4px;
}
.consult-modal-form::-webkit-scrollbar {
  width: 4px;
}
.consult-modal-form::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}
.consult-field-group {
  margin-bottom: 20px;
}
.consult-field-group:last-child {
  margin-bottom: 0;
}
.consult-label {
  display: block;
  margin-bottom: 8px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
color: #FFFFFF;
}
.consult-field {
  width: 100%;
  box-sizing: border-box;
  height: 34px;
  padding: 0 14px;
  border: 1px solid #3A3A3A;
  border-radius: 8px;
  background: #2A2A2A;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  outline: none;
}
.consult-field:not(.consult-field--select):placeholder-shown {
  color: #767676;
}
.consult-field::placeholder {
  color: #767676;
}
.consult-field--select.consult-field--muted {
  color: #767676;
}
.consult-field:focus {
  border-color: rgba(118, 87, 255, 0.55);
}
.consult-field--textarea {
  height: auto;
  min-height: 88px;
  padding: 12px 14px;
  resize: vertical;
  line-height: 1.5;
}
.consult-select-wrap {
  position: relative;
}
.consult-select-wrap::after {
  content: '›';
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: rgba(255, 255, 255, 0.4);
  line-height: 1;
  pointer-events: none;
}
.consult-field--select {
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  padding-right: 36px;
}
.consult-field--select option {
  background: #2b2b2b;
  color: #fff;
}
.consult-modal-footer {
  flex-shrink: 0;
  padding-top: 24px;
}
.consult-submit-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #7657ff 0%, #a357ff 100%);
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}
.consult-submit-btn:hover:not(:disabled) {
  opacity: 0.95;
}
.consult-submit-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.main-content {
  flex: 1;
  min-height: 0;
  padding-top: 60px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* background:#111213; */
  background:#05070b;
}

.main-content--no-header {
  padding-top: 0;
}
:deep(.main-content > *) {
  flex: 1;
  min-height: 0;
}

@media (max-width: 768px) {
  .header {
    height: auto;
  }

  .header-container {
    padding: 8px 12px 10px;
  }

  .header-content {
    flex-wrap: wrap;
    gap: 8px 10px;
    align-items: center;
  }

  .logo-img {
    width: 96px;
    height: 22px;
  }

  .header-center {
    order: 3;
    flex: 1 1 100%;
    padding: 0;
    min-width: 0;
  }

  .search-box {
    max-width: none;
    height: 36px;
    border-radius: 18px;
  }

  .search-input {
    padding: 4px 10px;
    font-size: 13px;
    min-width: 0;
  }

  .search-btn {
    padding: 4px 8px;
    gap: 0;
    flex-shrink: 0;
  }

  .search-divider {
    display: none;
  }

  .search-text {
    display: none;
  }

  .user-info {
    margin-left: auto;
    gap: 8px;
    align-items: center;
  }

  .header-icon-group {
    gap: 2px;
  }

  /* 移动端顶栏空间有限，暂隐藏“全部产品”入口 */
  .all-products-trigger {
    display: none;
  }

  .icon-img {
    width: 36px;
    height: 30px;
  }

  .goto-video-img {
    width: 72px;
    height: 30px;
  }

  .login-img {
    width: 56px;
    height: 28px;
  }

  .user-avatar {
    width: 28px;
    height: 28px;
  }

  .user-trigger {
    padding: 0;
  }

  .main-content {
    padding-top: 96px;
  }

  .vip-popup,
  .user-popup,
  .mobile-popup {
    top: 96px;
    right: 12px;
  }
}

@media (max-width: 400px) {
  .goto-video-link {
    display: none;
  }
}

.mobile-guide-mask {
  position: fixed;
  inset: 0;
  background: rgba(5, 7, 11, 0.78);
  backdrop-filter: blur(4px);
  z-index: 10020;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.mobile-guide-modal {
  position: relative;
  width: min(360px, 100%);
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  padding: 24px 20px 20px;
  background: linear-gradient(180deg, #242424 0%, #1a1a1a 100%);
  border: 1px solid rgba(118, 87, 255, 0.35);
  border-radius: 20px;
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.55), 0 0 0 1px rgba(255, 255, 255, 0.04) inset;
  text-align: center;
  box-sizing: border-box;
  animation: mobile-guide-in 0.28s ease-out;
}

@keyframes mobile-guide-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.mobile-guide-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.65);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.mobile-guide-title {
  margin: 0 0 10px;
  padding-top: 4px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  color: #ffffff;
}

.mobile-guide-desc {
  margin: 0 0 18px;
  font-size: 13px;
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.72);
  text-align: left;
}

.mobile-guide-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 18px;
}

.mobile-guide-option {
  padding: 14px 14px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: left;
}

.mobile-guide-option-tag {
  display: inline-block;
  margin-bottom: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
}

.mobile-guide-option-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}

.mobile-guide-link {
  display: inline-block;
  font-size: 13px;
  color: #a78bff;
  word-break: break-all;
  text-decoration: none;
}

.mobile-guide-mini-name {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}

.mobile-guide-qrcode-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.mobile-guide-qrcode {
  display: block;
  width: 132px;
  height: 132px;
  object-fit: contain;
  background: #ffffff;
  border-radius: 14px;
  padding: 8px;
  box-sizing: border-box;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.mobile-guide-qrcode-tip {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
}

.mobile-guide-confirm {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #7657ff 0%, #a357ff 100%);
  color: #ffffff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.mobile-guide-confirm:active {
  opacity: 0.92;
}
</style>
